import React, { useState } from "react";
import { Form, Tooltip, Button, Spin, Drawer } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useEngagementStore } from "./store";
import RenderFilterFields from "./RenderFilterFields";
import dayjs from "dayjs";

function MyWorkFilter({ disableButton }) {
  const {
    queryParams,
    setQueryParams,
    filtersData,
    filtersLoading,
    updateQueryParams,
  } = useEngagementStore();

  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);

  const handleFilterSubmit = (values) => {
    if (values.callDate) {
      values.callDate = `[${values?.callDate[0].format(
        "YYYY-MM-DD"
      )},${values?.callDate[1].format("YYYY-MM-DD")}]`;
    }
    if (values.agents) {
      values.agents = JSON.stringify(values.agents);
    }
    setQueryParams(values);
    updateQueryParams({ ...queryParams, ...values });
    setVisible(false);
  };

  const handleClear = () => {
    form.resetFields();
    updateQueryParams({
      ...queryParams,
      agents: null,
      monthCount: 1,
      durationRangeInMinute: null,
      engagementType: null,
      gender: null,
      callDate: `[${dayjs().format("YYYY-MM-DD")},${dayjs().format(
        "YYYY-MM-DD"
      )}]`,
    });
    setVisible(false);
  };

  return (
    <Spin spinning={filtersLoading}>
      <Tooltip placement="top" title="Filter">
        <Button
          type="primary"
          shape="round"
          icon={<FilterOutlined />}
          disabled={disableButton}
          onClick={() => setVisible(true)}
        >
          Filter
        </Button>
      </Tooltip>
      <Drawer
        title="Filter for Assigned Order"
        placement="right"
        onClose={() => setVisible(false)}
        visible={visible}
        width="30%"
        zIndex={999999999}
      >
        <div className="popover-content" style={{ padding: "1rem" }}>
          <Form
            className="order-filter"
            form={form}
            layout="vertical"
            initialValues={{
              callDate: [dayjs(), dayjs()],
              agents: null,
              monthCount: 1,
              durationRangeInMinute: null,
            }}
            onFinish={handleFilterSubmit}
          >
            <RenderFilterFields filtersData={filtersData} />
            <div className="d-flex justify-content-between">
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
              <Button onClick={handleClear}>Clear</Button>
            </div>
          </Form>
        </div>
      </Drawer>
    </Spin>
  );
}

export default MyWorkFilter;
